import {
  FETCH_ADVERTISER,
  FETCH_BANNER_TYPE,
  FETCH_ADNUMBER,
  FETCH_SEARCH_RESULTS,
  CLEAR_SEARCH,
} from "../actions/types";

export const searchReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_ADVERTISER:
      return { type: "advertiser", term: action.payload };
    case FETCH_BANNER_TYPE:
      return { type: "bannerType", term: action.payload };
    case FETCH_ADNUMBER:
      return { type: "adnumber", term: action.payload };
    case FETCH_SEARCH_RESULTS:
      return action.payload;
    case CLEAR_SEARCH:
      return {};
    default:
      return state;
  }
};
